export default __webpack_public_path__ + "static/img/ochpower.e581ad9.svg";